import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IDirectorListState } from '../states/director-list.state';

export const selectDirectorListState = createFeatureSelector<IDirectorListState>('directorList');

export const selectDirectorSearchFilter = createSelector(
  selectDirectorListState,
  (state: IDirectorListState) => state.searchFilter
);

export const selectDirectorPagination = createSelector(
  selectDirectorListState,
  (state: IDirectorListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectDirectorSort = createSelector(
  selectDirectorListState,
  (state: IDirectorListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectDirectorListFullState = createSelector(
  selectDirectorListState,
  (state: IDirectorListState) => state
);
